import React from 'react';
import './StainedGlass.css';

export default function StainedGlass() {
  return (
    <div className="stained-glass" aria-hidden="true">
      <img src="/images/sermon-stained-glass-chibi-jesus.jpg" alt="" width="887" height="1774" />
    </div>
  );
}
